import React from "react";
import { connect } from 'react-redux'

import store from '../../redux/store';
import { colyClient } from '../../services/Panel-initialisation.service';
import { getMessagesAsync, getMoreMessagesAsync, createMessageAsync, createNewMessage } from '../../redux/actions/messages.actions';
import { flashCharacterColorAsync } from '../../redux/actions/characters.actions';
import { stopAreaSelect, startAreaSelect, newZone, showZone, disableKeyboardMovement, enableKeyboardMovement, showHelp, startLooking, hideAllMenus } from '../../redux/actions/keyboard-shortcuts.actions';
import {
    selectCharacter,
    selectCharacters,
    selectCharacterZones,
    selectOrders,
    selectPanel,
    selectCharacterPanels,
    selectOrganisations,
    selectCharacterOrders,
    selectZones,
    selectAreaSelect,
    selectMaterialTypes,
    selectTileTypes,
    selectMineralTypes,
    selectToolTypes,
    selectMetalTypes,
    selectKeyTypes,
    selectFurnitureTypes,
    selectWritingSurfaceTypes,
    selectWritingImplementTypes,
    selectWorkshopTypes,
    selectWeaponTypes,
    selectArmourTypes,
    selectClothingTypes,
    selectJewelleryTypes,
    selectFoodTypes,
    selectFurnitureByPosition,
    selectFurnitureOrders,
} from '../../redux/selectors';
import { format, formatDistance, formatRelative, subDays } from 'date-fns';
import { createOrganisationAsync } from '../../redux/actions/organisation.actions'
import { deleteOrderAsync, updateOrderAsync, skipOrderAsync, createOrderAsync, deleteCompletedOrderAsync, updateCompletedOrderAsync } from '../../redux/actions/order.actions';
import { WORLD_WIDTH, WORLD_HEIGHT } from '../../services/biome-geography'

import Menu from '../utils/menu/Menu';
import TextInput from '../utils/text-input/TextInput';
import DirectionInput from '../utils/direction-input/DirectionInput';
import QuantityInput from '../utils/quantity-input/QuantityInput';

import { client } from '../../services/client';

import './Scheduler.css';

const SCHEDULE_REPETITIONS = {
    SINGLE_TIME: 's',
    ONCE_DAILY: 'd',
    INDEFINITE_DAILY: 'i',
    REACTION: 'r'
}

const SCHEDULE_REPETITION_TEXTS_MAP = {
    's': '',
    'd': ' Repeats Daily',
    'i': ' Repeat Until Sleep',
    'r': ' Reaction'
}

export const RESOURCE_OPTIONS = [
    {
        text: 'Armour',
        serviceName: 'armour-instances',
    },
    {
        text: 'Clothing',
        serviceName: 'clothing-instances',
    },
    {
        text: 'Food',
        serviceName: 'food-instances',
    },
    // {
    //     text: 'Furniture',
    //     serviceName: 'furniture-instances',
    // },
    // {
    //     text: 'Jewellery',
    //     serviceName: 'jewellery-instances',
    // },
    {
        text: 'Materials',
        serviceName: 'material-instances',
    },
    {
        text: 'Metals',
        serviceName: 'metal-instances',
    },
    {
        text: 'Minerals',
        serviceName: 'mineral-instances',
    },
    {
        text: 'Tools',
        serviceName: 'tool-instances',
    },
    {
        text: 'Weapons',
        serviceName: 'weapon-instances',
    },
    {
        text: 'Writing Surfaces',
        serviceName: 'writing-surface-instances',
    },
    {
        text: 'Tiles',
        serviceName: 'tile-instances',
    },
]

class Scheduler extends React.Component {
    onQuantityClosed;
    onQuantitySupplied;
    onTextInputSupplied;

    state = {
        navigationHandler: this.navigationHandler.bind(this),
        isRepetitionsMenuShowing: false,
        isTimePeriodMenuShowing: false,
        isTriggerPanelShowing: false,
        isResourceSelectShowing: false,
        isServiceMenuDisabled: false,
        isTypeMenuDisabled: true,
        isSearchShowing: false,
        updatedOrders: [],
        allowedResources: [],
        allowedResourceTypes: []
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.state.navigationHandler)
    }

    componentDidMount() {
        document.addEventListener('keydown', this.state.navigationHandler);

        if (this.props.areaSelect?.zoneSettings?.oldZone) {
            // update area select
            const selectedOrder = this.props.orders.find(order => order._id === this.props.areaSelect?.zoneSettings?.oldZone?.orderId)

            const panelAreas = [
                {
                    x: Math.min(this.props.areaSelect.startingCoords.x, this.props.areaSelect.x),
                    y: Math.min(this.props.areaSelect.startingCoords.y, this.props.areaSelect.y),
                    width: Math.abs(this.props.areaSelect.startingCoords.x - this.props.areaSelect.x) + 1,
                    height: Math.abs(this.props.areaSelect.startingCoords.y - this.props.areaSelect.y) + 1
                }
            ]

            if (selectedOrder.isCompleted) {
                this.props.updateCompletedOrderAsync({
                    _id: selectedOrder._id,
                    data: {
                        ...selectedOrder.data,
                        panelAreas,
                    },
                })

                if (selectedOrder.weight === SCHEDULE_REPETITIONS.ONCE_DAILY) {
                    this.props.updateOrderAsync({
                        _id: selectedOrder._id,
                        data: {
                            ...selectedOrder.data,
                            panelAreas,
                        }
                    })
                }

                return;
            }

            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                data: {
                    ...selectedOrder.data,
                    panelAreas,
                }
            })

            // clear area select
            this.props.stopAreaSelect();
        }
    }

    async navigationHandler(event) {
        if (this.state.isSearchShowing || this.state.isTextInputShowing || this.state.isSetOrderGroupInputShowing) {
            return;
        }

        if (this.props.isStoodOnDesk) {
            if (event.key === 's') {
                // We display a 'name the orders' ting
                this.setState({ isSetOrderGroupInputShowing: true });

                const nameOfOrders = await new Promise((resolve, reject) => {
                    this.setState({
                        onSetOrderGroupInputSupplied: (quantity) => {
                            this.setState({isSetOrderGroupInputShowing: false})
                            resolve(quantity);
                        },
                        onSetOrderGroupInputClosed: () => {
                            this.setState({isSetOrderGroupInputShowing: false})
                            reject('No quantity supplied');
                        }
                    })
                });

                if (!nameOfOrders) {
                    return;
                }

                colyClient.room.send('doAction', {
                    serviceName: 'orders',
                    name: 'storeDeskOrders',
                    orderGroupName: nameOfOrders,
                    orderGroupFurnitureId: this.props.isStoodOnDesk._id,
                    data: {
                        characterId: this.props.character._id
                    }
                });
                return;
            }

            if (event.key === 'l') {
                if (!this.props.isStoodOnDesk) {
                    return;
                }

                this.setState({ isShowOrderGroups: true });

                // We display a 'select from these' ting
                return;
            }

            if (this.state.isShowOrderGroups) {
                if (event.key === 'd') {
                    // We need to figure out which order we're highlighting

                    const selectedOrder = this.props.furnitureOrders.find(order => (order._id === this.state.selectedFurnitureOrder?._id));

                    // should display a confirmation ting also

                    // We display a 'delete from these' ting
                    colyClient.room.send('doAction', {
                        serviceName: 'orders',
                        name: 'deleteDeskOrder',
                        orderId: selectedOrder._id,
                        orderGroupFurnitureId: this.props.isStoodOnDesk._id,
                        data: {
                            characterId: this.props.character._id
                        }
                    });
                    return;
                }

                if (event.key === 'n') {
                    // We display a 'select from these' ting

                    const selectedOrder = this.props.furnitureOrders.find(order => (order._id === this.state.selectedFurnitureOrder?._id));
                    // we actually just want the group though :D
                    const orderGroupName = selectedOrder.orderGroupName;

                    // We display a 'delete from these' ting
                    colyClient.room.send('doAction', {
                        serviceName: 'orders',
                        name: 'replaceWithDeskOrders',
                        orderGroupName,
                        orderGroupFurnitureId: this.props.isStoodOnDesk._id,
                        data: {
                            characterId: this.props.character._id
                        }
                    });
                    return;
                }

                if (event.key === 'o') {
                    // We display a 'select from these' ting

                    const selectedOrder = this.props.furnitureOrders.find(order => (order._id === this.state.selectedFurnitureOrder?._id));
                    // we actually just want the group though :D
                    const orderGroupName = selectedOrder.orderGroupName;

                    colyClient.room.send('doAction', {
                        serviceName: 'orders',
                        name: 'appendWithDeskOrders',
                        orderGroupName,
                        orderGroupFurnitureId: this.props.isStoodOnDesk._id,
                        data: {
                            characterId: this.props.character._id
                        }
                    });
                    return;
                }
            }
        }

        if (this.state.isShowOrderGroups) {
            return;
        }

        if ((event.key === 's' || event.key === 'S') && !this.state.isQuantityInputShowing) {
            this.setState({
                isSearchShowing: true
            });
            return;
        }

        if (event.key === 'Escape' && this.state.isCharacterZoneSelectShowing) {
            this.setState({
                isCharacterZoneSelectShowing: false,
                isTriggerPanelShowing: true
            })

            event.preventDefault();
            return;
        }

        if (event.key === 'Escape' && !this.state.isSearchShowing && this.state.isResourceSelectShowing) {
            this.setState({
                isResourceSelectShowing: false,
                isTriggerPanelShowing: true
            })

            const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                resourceTypes: [...this.state.allowedResources.map(resource => resource.serviceName)],
                resources: [...this.state.allowedResourceTypes]
            })

            // TODO - save changes...?

            event.preventDefault();
            return;
        }

        if (this.state.isSetTextShowing || this.state.isMemberSelectShowing) {
            return;
        }

        if (this.state.isResourceSelectShowing && event.key === 'ArrowRight') {
            this.setState({
                isServiceMenuDisabled: true,
                isTypeMenuDisabled: false
            })
            
            return;
        }


        if (this.state.isResourceSelectShowing && event.key === 'ArrowLeft') {
            this.setState({
                isServiceMenuDisabled: false,
                isTypeMenuDisabled: true
            })
            
            return;
        }

        if (!this.state.isRepetitionsMenuShowing) {
            if (event.key === ',') {
                event.preventDefault();
                event.stopPropagation();
                if (this.state.selectedItem?.hint.indexOf('DONE') === -1) {
                    return;
                }

                const newSelectedItem = this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

                if (newSelectedItem.weight === SCHEDULE_REPETITIONS.REACTION) {
                    // TODO - we should just delete the completed order early here...
                    const orderToDelete = { ...this.state.selectedItem }

                    this.props.deleteCompletedOrderAsync({
                        ...orderToDelete
                    })
                    return;
                }

                if (!newSelectedItem) {
                    return;
                }

                this.props.createOrderAsync({
                    ...newSelectedItem,
                })

                return;
            }

            // if (event.key === '>') {
            //     if (!this.state.selectedItem) {
            //         return;
            //     }

            //     const orderToRepeat = this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

            //     if (orderToRepeat.weight === SCHEDULE_REPETITIONS.REACTION) {
            //         return;
            //     }

            //     const direction = await this.getDirection();

            //     this.setState({ isQuantityInputShowing: true });

            //     const quantity = await new Promise((resolve, reject) => {
            //         this.setState({
            //             onQuantitySupplied: (quantity) => {
            //                 this.setState({isQuantityInputShowing: false})
            //                 resolve(Number(quantity));
            //             },
            //             onQuantityClosed: () => {
            //                 this.setState({isQuantityInputShowing: false})
            //                 reject('No quantity supplied');
            //             }
            //         })
            //     });


            //     const { panelIds, zIndexes } = this.getPanelIds(orderToRepeat, direction, quantity);

            //     // If it's move, we just move one time x panels in direction of course.
            //     // For all the other orders, we have to fulfill the order on each panel in that direction.
            //     if (orderToRepeat.type === 'move') {
            //         if (panelIds.length > 0) {
            //             this.createOrder(orderToRepeat, panelIds[panelIds.length - 1]);
            //         } else if (zIndexes.length > 0) {
            //             this.createOrder(orderToRepeat, undefined, zIndexes[zIndexes.length - 1]);
            //         }
            //     } else {
            //         if (panelIds.length > 0) {
            //             panelIds.forEach(async (panelId) => {
            //                 this.createOrder(orderToRepeat, panelId);
            //             })
            //         } else if (zIndexes.length > 0) {
            //             zIndexes.forEach(async (z) => {
            //                 this.createOrder(orderToRepeat, undefined, z);
            //             })
            //         }
            //     }

            //     return;
            // }

            if (event.key === 'i') {
                event.preventDefault();
                event.stopPropagation();

                const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

                console.log('selectedOrder: ', [...selectedOrder.resourceTypes], [...selectedOrder.resources])

                this.setState({
                    isTriggerPanelShowing: true,
                    allowedResources: selectedOrder.resourceTypes?.map(allowedResource => (RESOURCE_OPTIONS.find(option => (option.serviceName === allowedResource)))) || [],
                    allowedResourceTypes: selectedOrder.resources || [],
                });
                return;
            }

            if (event.key === 'v') {
                event.preventDefault();
                event.stopPropagation();
                this.showScheduledArea(this.state.selectedItem)
            }

            if (event.key === 'q') {
                event.preventDefault();
                event.stopPropagation();
                this.editQuantity(this.state.selectedItem)
            }

            if (event.key === 'r') {
                event.preventDefault();
                event.stopPropagation();
                const newSelectedItem = this.state.orders.find(order => (order._id === this.state.selectedItem?._id))

                if (!newSelectedItem) {
                    return;
                }

                if (newSelectedItem.weight === SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }

                this.setState({
                    isRepetitionsMenuShowing: true,
                    selectedItem: {
                        ...this.state.selectedItem,
                        weight: newSelectedItem.weight
                    }
                })
                return;
            }

            if (event.key === 't') {
                event.preventDefault();
                event.stopPropagation();
                const newSelectedItem = this.state.orders.find(order => (order._id === this.state.selectedItem?._id))

                if (!newSelectedItem) {
                    return;
                }

                this.setState({
                    isTimePeriodMenuShowing: true,
                    selectedItem: {
                        ...newSelectedItem,
                        timePeriods: newSelectedItem.timePeriods || '111111'
                    }
                })
                return;
            }

            if (event.key === 'p') {
                event.preventDefault();
                event.stopPropagation();
                const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

                if (selectedOrder.weight !== SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }

                this.setState({
                    isCharacterPanelSelectShowing: true
                })

                return;
            }

            if (event.key === 'c') {
                event.preventDefault();
                event.stopPropagation();
                const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

                if (selectedOrder.weight !== SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }

                this.setState({
                    isCharacterSelectShowing: true
                })

                return;
            }

            if (event.key === 'g') {
                event.preventDefault();
                event.stopPropagation();
                const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

                if (selectedOrder.weight !== SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }

                this.setState({
                    isCharacterOrganisationSelectShowing: true
                })

                return;
            }

            if (event.key === 'x') {
                event.preventDefault();
                event.stopPropagation();
                if (this.state.selectedItem?.hint.indexOf('DONE') > -1) {
                    return;
                }

                // skip for the day!
                const orderToSkip = this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

                if (!orderToSkip || orderToSkip?.isCompleted) {
                    return;
                }

                this.props.skipOrderAsync({
                    ...orderToSkip,
                })
            }

            if (event.key === 'd') {
                event.preventDefault();
                event.stopPropagation();
                const orderToDelete = this.props.orders.find(order => order._id === this.state.selectedItem._id)

                if (!orderToDelete || !orderToDelete._id) {
                    return;
                }

                if (orderToDelete.weight === SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }

                const orderToDeleteIndex = this.state.orders.findIndex(order => (order._id === orderToDelete._id));

                const newOrders = [ ...this.state.orders ]
                newOrders.splice(orderToDeleteIndex, 1);

                this.setState({
                    isRepetitionsMenuShowing: false,
                    updatedOrders: [ ...newOrders ],
                    orders: [ ...newOrders ]
                })

                if (orderToDelete.isCompleted || orderToDelete.isFullyCompleted) {

                    if (orderToDelete.weight === SCHEDULE_REPETITIONS.ONCE_DAILY) {
                        this.props.deleteOrderAsync({
                            ...orderToDelete
                        })

                        setTimeout(() => {
                            this.props.deleteCompletedOrderAsync({
                                ...orderToDelete
                            })
                        }, 500)

                        return;
                    }

                    this.props.deleteCompletedOrderAsync({
                        ...orderToDelete
                    })

                    return;
                }

                this.props.deleteOrderAsync({
                    ...orderToDelete
                })

                return;
            }

            if (event.key === 'w') {
                event.preventDefault();
                event.stopPropagation();
                const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

                if (selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }

                this.setState({ isQuantityInputShowing: true });
    
                const quantity = await new Promise((resolve, reject) => {
                    this.setState({
                        onQuantitySupplied: (quantity) => {
                            this.setState({isQuantityInputShowing: false})
                            resolve(Number(quantity));
                        },
                        onQuantityClosed: () => {
                            this.setState({isQuantityInputShowing: false})
                            reject('No quantity supplied');
                        }
                    })
                });

                if (selectedOrder.isCompleted) {
                    this.props.updateCompletedOrderAsync({
                        ...selectedOrder,
                        data: {
                            ...selectedOrder.data,
                        },
                        priority: quantity
                    })

                    if (selectedOrder.weight === SCHEDULE_REPETITIONS.ONCE_DAILY) {
                        this.props.updateOrderAsync({
                            _id: selectedOrder._id,
                            priority: quantity
                        })
                    }

                    return;
                }
    
                this.props.updateOrderAsync({
                    _id: selectedOrder._id,
                    priority: quantity
                })
    
                return;
            }
        }

        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

        if (!selectedOrder) {
            return;
        }

        if (selectedOrder.weight === SCHEDULE_REPETITIONS.REACTION) {
            if (event.key === 'o') {
                event.preventDefault();
                event.stopPropagation();
                if (selectedOrder.weight !== SCHEDULE_REPETITIONS.REACTION) {
                    return;
                }
    
                this.props.updateOrderAsync({
                    ...selectedOrder,
                    data: {
                        ...selectedOrder.data,
                        isOn: !selectedOrder.data.isOn
                    }
                })
                return;
            }
    
            if (event.key === 'h') {
                event.preventDefault();
                event.stopPropagation();
                this.setState({ isQuantityInputShowing: true });
    
                const quantity = await new Promise((resolve, reject) => {
                    this.setState({
                        onQuantitySupplied: (quantity) => {
                            this.setState({isQuantityInputShowing: false})
                            resolve(Number(quantity));
                        },
                        onQuantityClosed:() => {
                            this.setState({isQuantityInputShowing: false})
                            reject('No quantity supplied');
                        }
                    })
                });
    
                this.props.updateOrderAsync({
                    ...selectedOrder,
                    data: {
                        ...selectedOrder.data,
                        hunger: quantity
                    }
                })
    
                return;
            }
    
            if (event.key === 'e') {
                event.preventDefault();
                event.stopPropagation();
                this.setState({ isQuantityInputShowing: true });
    
                const quantity = await new Promise((resolve, reject) => {
                    this.setState({
                        onQuantitySupplied: (quantity) => {
                            this.setState({isQuantityInputShowing: false})
                            resolve(Number(quantity));
                        },
                        onQuantityClosed: () => {
                            this.setState({isQuantityInputShowing: false})
                            reject('No quantity supplied');
                        }
                    })
                });
    
                this.props.updateOrderAsync({
                    ...selectedOrder,
                    data: {
                        ...selectedOrder.data,
                        healthPoints: quantity
                    }
                })
    
                return;
            }
        }


        if (event.key === 'Escape' && this.state.isCharacterPanelSelectShowing) {
            event.preventDefault();
            this.setState({
                isCharacterPanelSelectShowing: false
            })
            return;
        }


        if (event.key === 'Escape' && this.state.isTriggerPanelShowing) {
            event.preventDefault();
            this.setState({
                isTriggerPanelShowing: false
            })
            return;
        }

        if (event.key === 'Escape' && this.state.isCharacterSelectShowing) {
            event.preventDefault();
            this.setState({
                isCharacterSelectShowing: false
            })
            return;
        }

        if (event.key === 'Escape' && this.state.isCharacterOrganisationSelectShowing) {
            event.preventDefault();
            this.setState({
                isCharacterOrganisationSelectShowing: false
            })
            return;
        }

        if (event.key === 'Escape' && this.state.isTimePeriodMenuShowing) {
            event.preventDefault();

            const updatedOrder = { ...this.state.selectedItem }

            if (!this.state.timePeriods) {
                this.setState({
                    isTimePeriodMenuShowing: false,
                })
                return;
            }

            this.props.updateOrderAsync({
                _id: updatedOrder._id,
                timePeriods: this.state.timePeriods
            })

            this.setState({
                isTimePeriodMenuShowing: false,
            })
            return;
        }

        if (event.key === 'Escape' && this.state.isRepetitionsMenuShowing) {
            event.preventDefault();
            const updatedOrder = { ...this.state.selectedItem }
            const updatedOrderIndex = this.state.orders.findIndex(order => (order._id === updatedOrder._id));

            const newOrders = [ ...this.state.orders ]
            newOrders[updatedOrderIndex] = { ...this.state.selectedItem }

            if (updatedOrder.weight !== SCHEDULE_REPETITIONS.SINGLE_TIME && updatedOrder.hint.indexOf('DONE') > -1) {
                const existingOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

                if (existingOrder.isCompleted && existingOrder.weight === SCHEDULE_REPETITIONS.SINGLE_TIME) {
                    await this.props.createOrderAsync({
                        ...existingOrder,
                        weight: updatedOrder.weight
                    })

                    this.setState({
                        isRepetitionsMenuShowing: false,
                    })

                    return;
                }
            }

            if (updatedOrder.weight === SCHEDULE_REPETITIONS.SINGLE_TIME) {
                // Change order to put new order at the top (but at the bottom of the top list)
                const lastNonRepeatingOrderIndex = this.state.orders.findLastIndex(order => (order.weight === ''))

                const newOrders = [ ...this.state.orders ]
                const itemToMove = newOrders.splice(updatedOrderIndex, 1)[0]

                newOrders.splice(lastNonRepeatingOrderIndex + 1, 0, updatedOrder);

                this.setState({
                    isRepetitionsMenuShowing: false,
                    updatedOrders: [ ...newOrders ],
                    orders: [ ...newOrders ],
                    selectedItem: { ...newOrders[updatedOrderIndex] }
                })

                this.props.updateOrderAsync({
                    ...updatedOrder
                })

                return;
            }

            if (updatedOrder.weight === SCHEDULE_REPETITIONS.INDEFINITE_DAILY) {
                // IF you do not already have one of these orders
                const existingRepeatUntilSleepOrder = this.state.orders.find(order => (order.weight === SCHEDULE_REPETITIONS.INDEFINITE_DAILY))

                if (existingRepeatUntilSleepOrder) {
                    existingRepeatUntilSleepOrder.weight = SCHEDULE_REPETITIONS.ONCE_DAILY;

                    this.props.updateOrderAsync({
                        ...existingRepeatUntilSleepOrder
                    })
                }

                const newOrders = [ ...this.state.orders.filter(item => (item._id !== updatedOrder._id)), { ...updatedOrder} ]

                this.setState({
                    isRepetitionsMenuShowing: false,
                    updatedOrders: [ ...newOrders ],
                    orders: [ ...newOrders ],
                    selectedItem: { ...newOrders[updatedOrderIndex] }
                })

                this.props.updateOrderAsync({
                    ...updatedOrder
                })
                return;
            }

            this.props.updateOrderAsync({
                ...updatedOrder
            })

            this.setState({
                isRepetitionsMenuShowing: false,
                updatedOrders: [ ...this.state.updatedOrders, { ...this.state.selectedItem } ],
                orders: [ ...newOrders ],
            })
            return;
        }
    }

    onSearchExit(event) {
        this.setState({
            isSearchShowing: false,
        })
        event.preventDefault();
        return;
    }

    onSearchSubmit(text) {
        this.setState({
            isSearchShowing: false,
            searchString: text,
        })
    }

    onSearchUpdate(text) {
        this.setState({
            searchString: text,
        })
    }

    getPanelIds(orderToRepeat, direction, quantity) {
        let panelId = orderToRepeat.data?.panelId || orderToRepeat.panelId;
        let z = orderToRepeat.z;

        if (!panelId) {
            throw new Error('Cannot repeat in direction for an order without a panel id')
        }

        let panelIds = [];
        let zIndexes = [];

        if (direction === 'north') {
            for (var i=0; i < quantity; i++) {
                panelId = panelId - WORLD_WIDTH;
                panelIds.push(panelId)
            }
        }

        if (direction === 'east') {
            for (var i=0; i < quantity; i++) {
                panelId = panelId + 1;
                panelIds.push(panelId)
            }
        }

        if (direction === 'south') {
            for (var i=0; i < quantity; i++) {
                panelId = panelId + WORLD_WIDTH;
                panelIds.push(panelId)
            }
        }

        if (direction === 'west') {
            for (var i=0; i < quantity; i++) {
                panelId = panelId - 1;
                panelIds.push(panelId)
            }
        }

        if (direction === 'up') {
            for (var i=0; i < quantity; i++) {
                z = z + 1;
                zIndexes.push(z)
            }
        }

        if (direction === 'down') {
            for (var i=0; i < quantity; i++) {
                z = z - 1;
                zIndexes.push(z)
            }
        }

        return { panelIds, zIndexes };
    }

    selectCharacterPanel(characterPanel) {
        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

        let updatedPanelIds = [];

        if (selectedOrder.data?.panelIds) {
            if (selectedOrder.data.panelIds.find(panelId => panelId === characterPanel.panelId)) {
                // Remove it
                updatedPanelIds = [ ...selectedOrder.data.panelIds.filter(panelId => (panelId !== characterPanel.panelId)) ];
            } else {
                // Add it
                updatedPanelIds = [ ...selectedOrder.data.panelIds, characterPanel.panelId ];
            }
        } else {
            // Add it
            updatedPanelIds.push(characterPanel.panelId);
        }

        this.props.updateOrderAsync({
            ...selectedOrder,
            data: {
                ...selectedOrder.data,
                panelIds: updatedPanelIds
            }
        })
    }

    selectCharacter(character) {
        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

        let updatedCharacterIds = [];

        if (selectedOrder.data?.characterIds) {
            if (selectedOrder.data.characterIds.find(characterId => characterId === character._id)) {
                // Remove it
                updatedCharacterIds = [ ...selectedOrder.data.characterIds.filter(characterId => (characterId !== character._id)) ];
            } else {
                // Add it
                updatedCharacterIds = [ ...selectedOrder.data.characterIds, character._id ];
            }
        } else {
            // Add it
            updatedCharacterIds.push(character._id);
        }

        this.props.updateOrderAsync({
            ...selectedOrder,
            data: {
                ...selectedOrder.data,
                characterIds: updatedCharacterIds
            }
        })
    }

    selectOrganisation(organisation) {
        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

        let updatedOrganisationIds = [];

        if (selectedOrder.data?.organisationIds) {
            if (selectedOrder.data.organisationIds.find(organisationId => organisationId === organisation._id)) {
                // Remove it
                updatedOrganisationIds = [ ...selectedOrder.data.organisationIds.filter(organisationId => (organisationId !== organisation._id)) ];
            } else {
                // Add it
                updatedOrganisationIds = [ ...selectedOrder.data.organisationIds, organisation._id ];
            }
        } else {
            // Add it
            updatedOrganisationIds.push(organisation._id);
        }

        this.props.updateOrderAsync({
            ...selectedOrder,
            data: {
                ...selectedOrder.data,
                organisationIds: updatedOrganisationIds
            }
        })
    }

    async createOrder(orderToRepeat, panelId, z) {
        if (panelId !== undefined) {
            await this.props.createOrderAsync({
                ...orderToRepeat,
                data: {
                    ...orderToRepeat.data,
                    panelId: orderToRepeat.data.panelId ? panelId : undefined
                },
                panelId,
            })
        }

        if (z !== undefined) {
            await this.props.createOrderAsync({
                ...orderToRepeat,
                data: {
                    ...orderToRepeat.data,
                    z: orderToRepeat.data.z ? Math.min(z, 0) : undefined
                },
                z: Math.min(z, 0),
            })
        }
    }

    getDirection() {
        this.setState({ isDirectionInputShowing: true });

        return new Promise((resolve, reject) => {
            this.onDirectionSupplied = (direction) => {
                this.setState({isDirectionInputShowing: false})
                resolve(direction);
            }

            this.onDirectionClosed = () => {
                this.setState({isDirectionInputShowing: false})
                reject('No direction supplied');
            }
        });
    }

    setRepetition(repetition) {
        const oldOrder = this.state.selectedItem

        this.setState({
            selectedItem: {
                ...oldOrder,
                weight: (repetition.text === ' No Repetitions') ? SCHEDULE_REPETITIONS.SINGLE_TIME : (repetition.text === ' Repeats Daily') ? SCHEDULE_REPETITIONS.ONCE_DAILY : SCHEDULE_REPETITIONS.INDEFINITE_DAILY
            }
        })
    }

    setTimePeriod(selectedTimePeriodItem) {
        let timePeriod = 0;

        switch (selectedTimePeriodItem.text) {
            case ' Dawn': 
                timePeriod = 0;
                break;
            case ' Early Day': 
                timePeriod = 1;
                break;
            case ' Late Day': 
                timePeriod = 2;
                break;
            case ' Dusk': 
                timePeriod = 3;
                break;
            case ' Early Night': 
                timePeriod = 4;
                break;
            case ' Late Night': 
                timePeriod = 5;
                break;
        }
        
        let newTimePeriod = this.state.selectedItem.timePeriods.split('');

        if (newTimePeriod[timePeriod] === '1') {
            newTimePeriod[timePeriod] = '0';
        } else {
            newTimePeriod[timePeriod] = '1';
        }

        this.setState({
            selectedItem: {
                ...this.state.selectedItem,
                timePeriods: newTimePeriod.join('')
            },
            timePeriods: newTimePeriod.join('')
        })
    }

    onOrderChosen(order) {
        this.setState({
            selectedItem: order
        })
    }

    async editQuantity(orderSetup) {
        const order = this.props.orders.find(order => orderSetup._id === order._id)
        
        if (order.type === 'create' || order.type === 'fetch') {
            // show quantity input
            this.setState({
                isQuantityInputShowing: true
            })

            const quantity = await new Promise((resolve, reject) => {
                this.setState({
                    onQuantitySupplied: (quantity) => {
                        this.setState({isQuantityInputShowing: false})
                        resolve(Number(quantity));
                    },
                    onQuantityClosed: () => {
                        this.setState({isQuantityInputShowing: false})
                        reject('No quantity supplied');
                    }
                })
            });

            console.log('you are here my dyood');

            if (order.isCompleted) {
                this.props.updateCompletedOrderAsync({
                    ...order,
                    data: {
                        ...order.data,
                        quantity,
                        initialQuantity: quantity
                    },
                })
            }

            this.props.updateOrderAsync({
                ...order,
                data: {
                    ...order.data,
                    quantity,
                    initialQuantity: quantity
                }
            })
            return;
        }
    }

    async showScheduledArea(orderSetup) {
        const order = this.props.orders.find(order => orderSetup._id === order._id)
        
        if (order.data?.panelId && order.data?.panelId !== this.props.character.panelId) {
            return;
        }

        let panelAreas = order.data?.panelAreas

        if (order.data?.panelAreas.length === 0) {
            panelAreas.push({
                width: 1,
                height: 1,
                x: order.x === undefined ? order.data.x : order.x,
                y: order.y === undefined ? order.data.y : order.y
            })
        }

        this.props.hideAllMenus()

        const panelArea = order.data?.panelAreas[0]

        this.props.startAreaSelect({
            isStartOfAreaSelect: true,
            areaSelectType: 'update',
            zoneSettings: {
                oldZone: {
                    width: panelArea.width,
                    height: panelArea.height,
                    x: panelArea.x,
                    y: panelArea.y,
                    orderId: order._id
                }
            },
            position: {
                ...this.props.character.position
            },
            coords: {
                ...this.props.character.position
            }
        })
    }

    static getDerivedStateFromProps(props, state) {
        function sortOrders(itemA, itemB) {
            const itemAGrouping = itemA.orderGroupName && itemA.orderGroupFurnitureId && itemA.orderGroupName + itemA.orderGroupFurnitureId;
            const itemBGrouping = itemB.orderGroupName && itemB.orderGroupFurnitureId && itemB.orderGroupName + itemB.orderGroupFurnitureId;
            if (itemAGrouping && itemBGrouping && itemAGrouping.localeCompare(itemBGrouping) !== 0) {
                return itemAGrouping.localeCompare(itemBGrouping);
            }

            if (itemAGrouping && !itemBGrouping) {
                return 1
            }

            if (itemAGrouping && !itemBGrouping) {
                return -1
            }

            if (itemA.weight === SCHEDULE_REPETITIONS.REACTION && itemB.weight !== SCHEDULE_REPETITIONS.REACTION) {
                return 1;
            }

            if (itemB.weight === SCHEDULE_REPETITIONS.REACTION && itemA.weight !== SCHEDULE_REPETITIONS.REACTION) {
                return -1;
            }

            if(itemA.triggerType && itemB.triggerType) {
                if (itemA.triggerType === itemB.triggerType) {
                    // triggerZoneId
                    if (itemA.triggerZoneId && itemB.triggerZoneId && itemA.triggerZoneId === itemB.triggerZoneId) {
                        return itemA.triggerZoneId.localeCompare(itemB.triggerZoneId)
                    }

                    if (itemA.triggerZoneId) {
                        return 1
                    }

                    if (itemA.triggerZoneId) {
                        return -1
                    }

                    // triggerText
                    // TODO: triggerSurname
                    if (itemA.triggerText && itemB.triggerText) {
                        if (itemA.triggerText === itemB.triggerText) {
                            return itemA.priority - itemB.priority
                        }
                        return itemA.triggerText.localeCompare(itemB.triggerText)
                    }

                    if (itemA.triggerText) {
                        return 1
                    }

                    if (itemA.triggerText) {
                        return -1
                    }
                }

                return itemA.triggerType.localeCompare(itemB.triggerType)
            }

            if(itemA.triggerType && !itemB.triggerType) {
                return 1;
            }

            if(!itemA.triggerType && itemB.triggerType) {
                return -1;
            }

            if (itemA.weight === SCHEDULE_REPETITIONS.SINGLE_TIME && itemB.weight !== SCHEDULE_REPETITIONS.SINGLE_TIME) {
                return -1
            }

            if (itemB.weight === SCHEDULE_REPETITIONS.SINGLE_TIME && itemA.weight !== SCHEDULE_REPETITIONS.SINGLE_TIME) {
                return 1
            }

            if (itemA.weight === SCHEDULE_REPETITIONS.ONCE_DAILY && itemB.weight !== SCHEDULE_REPETITIONS.ONCE_DAILY) {
                return -1
            }

            if (itemB.weight === SCHEDULE_REPETITIONS.ONCE_DAILY && itemA.weight !== SCHEDULE_REPETITIONS.ONCE_DAILY) {
                return 1
            }

            if (itemA.weight === SCHEDULE_REPETITIONS.INDEFINITE_DAILY && itemB.weight !== SCHEDULE_REPETITIONS.INDEFINITE_DAILY) {
                return -1
            }

            if (itemB.weight === SCHEDULE_REPETITIONS.INDEFINITE_DAILY && itemA.weight !== SCHEDULE_REPETITIONS.INDEFINITE_DAILY) {
                return 1
            }
            if (itemA.isCompleted && !itemB.isCompleted) {
                return 1
            }

            if (!itemA.isCompleted && itemB.isCompleted) {
                return -1
            }

            if (itemA.priority === itemB.priority) {
                return itemA._id.toLowerCase().localeCompare(itemB._id.toLowerCase())
            }

            return itemA.priority - itemB.priority
        }

        function mapOrders(order) {
            const character = props.character;

            if (!order) {
                return;
            }

            let directionString = '';

            if (order.panelId || order.data?.panelId) {
                const panelId = order.data?.panelId || order.panelId;

                const targetX = panelId % WORLD_WIDTH;
                const targetY = Math.floor(panelId / WORLD_WIDTH);

                // find coords of current panel
                const currentX = character.panelId % WORLD_WIDTH;
                const currentY = Math.floor(character.panelId / WORLD_WIDTH);

                // transform so current panel === 0,0
                const x = currentX - targetX
                const y = currentY - targetY
                const z = character.z - order.z

                let directionXString = `${x} Panels West`;

                if (x < 0) {
                    directionXString = `${x * -1} Panels East`
                }

                let directionYString = `${y} Panels North`;

                if (y < 0) {
                    directionYString = `${y * -1} Panels South`
                }

                let directionZString = `${z} Panels Down`;

                if (z < 0) {
                    directionZString = `${z} Panels Up`
                }

                if (x === 0) {
                    directionXString = ''
                }

                if (y === 0) {
                    directionYString = ''
                }

                if (isNaN(z) || z === 0) {
                    directionZString = ``
                }

                if (x === 0 && y === 0 && (isNaN(z) || z === 0)) {
                    let __x = order.x !== undefined ? order.x : order.data.x;
                    let __y = order.y !== undefined ? order.y : order.data.y;

                    if (order.data && order.data.panelAreas && order.data.panelAreas[0]) {
                        __x = order.data.panelAreas[0].x
                        __y = order.data.panelAreas[0].y
                    }

                    const _x = character.position.x - __x;
                    const _y = character.position.y - __y;

                    if (_x < 0) {
                        directionXString = `${_x * -1} Steps West`;
                    } else if (_x > 0) {
                        directionXString = `${_x} Steps East`;
                    } else {
                        directionXString = '';
                    }

                    if (order.data?.panelAreas && order.data?.panelAreas[0]) {
                        directionXString = `Starting at ${directionXString}`
                    }

                    if (_y < 0) {
                        directionYString = `${_y * -1} Steps South`;
                    } else if (_y > 0) {
                        directionYString = `${_y} Steps North`;
                    } else {
                        directionYString = '';
                    }
                }

                if (directionXString) {
                    directionYString = ` ${directionYString}`
                }

                if (directionZString) {
                    directionYString = `${directionYString} `
                }

                if (!directionXString && !directionYString && !directionZString) {
                    directionXString = 'Current Position'
                }

                directionString = `${directionXString}${directionYString}${directionZString}`
            }

            let text = order.type === 'gather' ? order.data?.resources : order.type;

            if (order.type === 'create') {
                const craftedCount = order.data?.initialQuantity - order.data?.quantity || 0
                const totalQuantity = order.data?.initialQuantity || order.data.quantity || 1
                text = `${text} ${craftedCount}/${totalQuantity} ${order.data.itemText}`
            }

            if (order.type === 'unload') {
                const stockpile = props.zones.find(zone => zone._id === order.data.zoneId);
                if (stockpile) {
                    text = `unload to ${stockpile?.name}`
                } else {
                    text = `unload to unknown stockpile`
                }
            }

            if (order.type === 'fetch') {
                text = `${text} ${order.data.initialQuantity || 1} ${order.data.itemText}`
            }

            if (order.type === 'haul') {
                const stockpile = props.zones.find(zone => zone._id === order.data.zoneId);
                if (stockpile) {
                    text = `haul to ${stockpile?.name} from [${order.data.panelAreas[0].x}, ${order.data.panelAreas[0].y}]`
                } else {
                    text = `haul to stockpile from [${order.data.panelAreas[0].x}, ${order.data.panelAreas[0].y}]`
                }
            }

            if (order.type === 'gather') {
                text = `${text}`
            }

            if (order.type === 'plant') {
                text = `${text} seeds`
            }

            if (order.type === 'build') {
                text = `${text} ${order.data.itemText}`
            }

            if (order.type === 'follow') {
                text = `${text} ${order.data.itemText}`
            }

            if (order.type === 'fight') {
                text = `${text} ${order.data.itemText}`
                // TODO: Display the name of the animal type youre attacking
                // or if its many, just write that :)
            }

            function stringifyTimePeriods(timePeriods) {
                if (!timePeriods) {
                    return '';
                }

                if (timePeriods === '000000') {
                    return ' [never] '
                }

                if (timePeriods === '111111') {
                    return ' [always] '
                }

                let string = ' [';
                const stringEnd = '] ';

                const timePeriodNames = ['dawn', 'early day', 'late day', 'dusk', 'early night', 'late night'];

                const timePeriodsArray = timePeriods.split('');

                timePeriodsArray.forEach((timePeriod, index) => {
                    if (timePeriod === '1') {
                        string += `${timePeriodNames[index]},`
                    }
                })

                string = string.slice(0, -1); // remove last comma

                string += stringEnd;


                return ` ${string} `
            }

            const timePeriodsString = stringifyTimePeriods(order.timePeriods);


            const isActiveString = order.isActive ? 'ACTIVE' : '';                

            return {
                text,
                hint: order.step > 0 ? `${timePeriodsString}${isActiveString} ${directionString}` : order.isCompleted ? `${timePeriodsString} DONE ${directionString}` : `${timePeriodsString}${isActiveString} ${directionString}`,
                weight: order.weight || SCHEDULE_REPETITIONS.SINGLE_TIME,
                tradePrice: SCHEDULE_REPETITION_TEXTS_MAP[order.weight || SCHEDULE_REPETITIONS.SINGLE_TIME],
                tradeOfferCount: order.priority,
                priority: order.priority,
                _id: order._id,
                className: (order.isFullyCompleted || order.isCompleted) ? 'disabled' : '',
                timePeriods: order.timePeriods
            }
        }
        state.orders = props.orders
            .sort((a, b) => sortOrders(a, b))
            .map(order => mapOrders(order))

        state.furnitureOrders = props.furnitureOrders
            .sort((a, b) => sortOrders(a, b))
            .map(order => mapOrders(order))

        return state;
    }

    isTimePeriodSelected(period) {
        return this.state.selectedItem.timePeriods[period] === '1';
    }

    onResourceChosen(option) {
        const isExistingOption = this.state.allowedResources.find(resource => (resource.serviceName === option.serviceName))

        if (isExistingOption) {
            this.setState({
                allowedResources: [ ...this.state.allowedResources.filter(resource => (resource.serviceName !== option.serviceName)) ]
            })
            return
        }

        this.setState({
            allowedResources: [ ...this.state.allowedResources, option ]
        })
    }

    onResourcesKeyPressed(option, event, selectedOption) {
        if (event.key === 'Escape' && !this.state.isSearchShowing) {
            this.setState({
                isResourceSelectShowing: false,
                isTriggerPanelShowing: true
            })

            this.saveChanges()

            event.preventDefault();
        }
    }

    onResourceTypeChosen(option) {
        if (!this.state.highlightedServiceName) {
            return;
        }

        const isExistingOptionService = this.state.allowedResources.find(resource => (resource.serviceName === this.state.highlightedServiceName))

        const isExistingOption = this.state.allowedResourceTypes.find(resourceId => (resourceId === option._id))

        if (isExistingOption) {
            this.setState({
                allowedResourceTypes: [ ...this.state.allowedResourceTypes.filter(resourceId => (resourceId !== option._id)) ]
            })
            return
        }

        this.setState({
            allowedResourceTypes: [ ...this.state.allowedResourceTypes, option._id ]
        })
    }

    onResourceServiceHighlighted(option) {
        this.setState({
            highlightedServiceName: option.serviceName
        })
    }

    onTypeChosen(option) {        
        this.setState({
            type: option.text
        })
    }

    getGroupingClass(_option) {
        const option = this.props.orders.find(order => order._id === _option._id) || this.props.furnitureOrders.find(order => order._id === _option._id);
        // triggerZoneId
        // triggerText
        // triggerSurname
        // triggerType

        // orderGroupName
        // orderGroupFurnitureId

        if (!option) {
            return;
        }

        if (option.orderGroupName) {
            return `__${option.orderGroupName.split(' ').join('-')}`
        }

        if (option.isTriggerOn) {
            if (option.triggerType === 'stockpile') {
                return `__${option.triggerZoneId}`;
            }
            if (option.triggerType === 'inventory') {
                // triggerNumber
                // triggerZoneId
                // isTriggered
                return `__${option.triggerType}`;
            }
            
            if (option.triggerType === 'spoken') {
                return `__${option.triggerText}-${option.triggerSurname}`;
            }
        }

    }

    getGroupText(_option) {
        const option = this.props.orders.find(order => order._id === _option._id) || this.props.furnitureOrders.find(order => order._id === _option._id);

        if (!option) {
            return;
        }

        if (option.orderGroupName) {
            return `Order Group: ${option.orderGroupName}`
        }
        
        if (option.isTriggerOn) {
            if (option.triggerType === 'stockpile') {
                return `Trigger: Only carry out order when stockpile contains ${option.triggerDirectionality === 'greaterThan' ? 'more than or equal to' : 'less than'} ${option.triggerNumber} of...`
            }
            if (option.triggerType === 'inventory') {
                // triggerNumber
                // triggerZoneId
                // isTriggered
                return `Trigger: Only carry out order when inventory contains ${option.triggerDirectionality === 'greaterThan' ? 'more than or equal to' : 'less than'} ${option.triggerNumber} of...`
            }
            if (option.triggerType === 'spoken') {
                return `Trigger: Only carry out order when ${option.triggerSurname || 'anyone'} says ${option.triggerText}`
            }
        }
    }

    async triggerSettings(option) {
        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

        if (option.text === 'Only carry out an order when...') {
            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                isTriggerOn: !selectedOrder.isTriggerOn,
            })
        }

        if (option.text === 'Stockpile') {
            this.setState({
                isCharacterZoneSelectShowing: true,
                isTriggerPanelShowing: false
            })
        }

        if (option.text === 'Inventory') {
            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                triggerType: 'inventory',
                triggerZoneId: ''
            })
        }

        if (option.text === 'Someone says... ') {
            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                triggerType: 'spoken',
                triggerZoneId: ''
            })
        }

        if (option.text === 'Surname: ') {
            // TODO - show quantity input, and update when it returns back
            this.setState({ isTextInputShowing: true });

            const surname = await new Promise((resolve, reject) => {
                this.setState({
                    onTextInputSupplied: (quantity) => {
                        this.setState({isTextInputShowing: false})
                        resolve(quantity);
                    },
                    onTextInputClosed: () => {
                        this.setState({isTextInputShowing: false})
                        reject('No quantity supplied');
                    }
                })
            });

            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                triggerSurname: surname
            })
        }

        if (option.text === 'says...') {
            // TODO - show quantity input, and update when it returns back
            this.setState({ isTextInputShowing: true });

            const says = await new Promise((resolve, reject) => {
                this.setState({
                    onTextInputSupplied: (quantity) => {
                        this.setState({isTextInputShowing: false})
                        resolve(quantity);
                    },
                    onTextInputClosed: () => {
                        this.setState({isTextInputShowing: false})
                        reject('No quantity supplied');
                    }
                })
            });

            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                triggerText: says
            })
        }

        if (option.text === 'Contains more than or equal to...') {
            // TODO - show quantity input, and update when it returns back
            this.setState({ isQuantityInputShowing: true });

            const quantity = await new Promise((resolve, reject) => {
                this.setState({
                    onQuantitySupplied: (quantity) => {
                        this.setState({isQuantityInputShowing: false})
                        resolve(Number(quantity));
                    },
                    onQuantityClosed: () => {
                        this.setState({isQuantityInputShowing: false})
                        reject('No quantity supplied');
                    }
                })
            });

            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                triggerNumber: quantity,
                triggerDirectionality: 'greaterThan',
            })
        }

        if (option.text === 'Contains less than...') {
            // TODO - show quantity input, and update when it returns back
            this.setState({ isQuantityInputShowing: true });

            const quantity = await new Promise((resolve, reject) => {
                this.setState({
                    onQuantitySupplied: (quantity) => {
                        this.setState({isQuantityInputShowing: false})
                        resolve(Number(quantity));
                    },
                    onQuantityClosed: () => {
                        this.setState({isQuantityInputShowing: false})
                        reject('No quantity supplied');
                    }
                })
            });

            this.props.updateOrderAsync({
                _id: selectedOrder._id,
                triggerNumber: quantity,
                triggerDirectionality: 'lessThan',
            })
        }

        if (option.text === 'of resources') {
            // TODO - show the item select :) it has 'anything' at the top, then all possible items searchable.

            this.setState({
                allowedResources: selectedOrder.resourceTypes?.map(allowedResource => (RESOURCE_OPTIONS.find(option => (option.serviceName === allowedResource)))) || [],
                allowedResourceTypes: selectedOrder.resources,
                isResourceSelectShowing: true,
                isTriggerPanelShowing: false
            })
        }
    }

    selectCharacterZone(characterZone) {
        console.log('characterZone', characterZone);
        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

        this.props.updateOrderAsync({
            _id: selectedOrder._id,
            triggerZoneId: characterZone._id,
            triggerType: 'stockpile',
        })
    }

    getResourceTypeOptions() {
        if (!this.state.highlightedServiceName) {
            return [];
        }

        let typeName = this.state.highlightedServiceName.split('-')[0] + 'Types';

        if (typeName === 'writingTypes') {
            typeName = 'writingSurfaceTypes'
        }

        return this.props[typeName].map((option) => {
            if (this.state.allowedResourceTypes.find(resourceId => resourceId === option._id)) {
                return {
                    ...option,
                    text: option.name,
                    hint: ' Selected'
                }
            }

            const isParentSelected = this.state.allowedResources.find(allowed => allowed.serviceName === this.state.highlightedServiceName)

            return {
                ...option,
                text: option.name,
                hint: isParentSelected ? ' Auto-Selected' : ''
            }
        })
        .filter((recipe) => {
            if (this.state.searchString) {
                if (!recipe.text) {
                    return -1
                }
                return recipe.text.toLowerCase().indexOf(this.state.searchString.toLowerCase()) > -1
            }

            return true;
        })
    }

    getAllowedResourcesHint() {

        if (this.state.allowedResources?.length === RESOURCE_OPTIONS.length) {
            return 'All'
        }

        // this.props.orders.find(order => (order._id === this.state.selectedItem?._id))

        const selectedResources = this.state.allowedResources.filter(Boolean)?.map(resource => (resource.text))

        const selectedResourceTypes = this.state.allowedResourceTypes.map(resourceId => {
            let result;
            RESOURCE_OPTIONS.find((option) => {
                const serviceKey = option.serviceName.split('-')[0] + 'Types'
                const resourceType = this.props[serviceKey].find(resourceType => (resourceType._id === resourceId))
                result = resourceType?.name
                return resourceType?.name
            })

            return result;
        })

        if (selectedResources.concat(selectedResourceTypes).join(', ').length > 250) {
            return (selectedResources.concat(selectedResourceTypes).join(', ')).slice(0, 250) + '...'
        }

        return selectedResources.concat(selectedResourceTypes).join(', ')
    }

    onFurnitureOrderChosen(option) {
        this.setState({
            selectedFurnitureOrder: option
        })
    }

    render() {
        const selectedOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));

        return (
            <div className="conversation-tree-wizard">

                {
                    this.state.isResourceSelectShowing ? (
                    <div className="conversation-tree-wizard-container">
                        <div className="top-ting">
                            <div className="my-inventory conversation-tree-wizard-container">
                                <Menu options={
                                        RESOURCE_OPTIONS.map((option) => {
                                            if (this.state.allowedResources.find(allowed => allowed.serviceName === option.serviceName)) {
                                                return {
                                                    ...option,
                                                    hint: ' Selected'
                                                }
                                            }

                                            // Find if any children are selected
                                            let typeName = option.serviceName.split('-')[0] + 'Types';

                                            if (typeName === 'writingTypes') {
                                                typeName = 'writingSurfaceTypes'
                                            }

                                            const isChildResourceTypeSelected = this.props[typeName].find((option) => {
                                                if (this.state.allowedResourceTypes.find(resourceId => resourceId === option._id)) {
                                                    return true;
                                                }
                                            });

                                            if (isChildResourceTypeSelected) {
                                                return {
                                                    ...option,
                                                    hint: ' Filtered'
                                                }
                                            }

                                            return option
                                        })
                                    }
                                    optionChosen={this.onResourceChosen.bind(this)}
                                    keyPressed={this.onResourcesKeyPressed.bind(this)}
                                    highlightedOption={this.onResourceServiceHighlighted.bind(this)}
                                    // navigation={this.onNavigation.bind(this)}
                                    menuContainer="conversation-tree-wizard-container"
                                    isDisabled={this.state.isServiceMenuDisabled}
                                />
                            </div>
                            <div className="tile-inventory">
                                <Menu options={
                                    this.getResourceTypeOptions()
                                }
                                optionChosen={this.onResourceTypeChosen.bind(this)}
                                keyPressed={this.onResourcesKeyPressed.bind(this)}
                                // navigation={this.onNavigation.bind(this)}
                                menuContainer="conversation-tree-wizard-container"
                                isDisabled={this.state.isTypeMenuDisabled}
                                />
                            </div>
                        </div>

                        {this.state.isSearchShowing ? (
                                    <div className="search-bar">
                                        <p className="conversation-wizard-exit"><span className="action">ESC</span> to exit</p>
                                        <TextInput onTextSubmit={this.onSearchSubmit.bind(this)} onTextUpdate={this.onSearchUpdate.bind(this)} text={''} exitKey="Escape" onExitKey={this.onSearchExit.bind(this)} />
                                    </div>
                                ) : ('')
                        }
                    </div>
                    ) :
                    this.state.isTriggerPanelShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={[
                                        {
                                            text: 'Only carry out an order when...',
                                            hint: this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).isTriggerOn ? '[on]' : '[off]',
                                            indentation: 0,
                                        },
                                        {
                                            text: 'Stockpile',
                                            hint: this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerType === 'stockpile' ? `[${this.props.zones.find(zone => zone._id === this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerZoneId)?.name }]` : '',
                                            indentation: 1,
                                        },
                                        {
                                            text: 'Inventory',
                                            hint: this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerType === 'inventory' ? '[selected]' : '',
                                            indentation: 1,
                                        },
                                        {
                                            text: 'Contains more than or equal to...',
                                            hint: ` [${this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerDirectionality === 'greaterThan' ? this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerNumber || 0 : 0}]`,
                                            indentation: 2,
                                        },
                                        {
                                            text: 'Contains less than...',
                                            hint: ` [${this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerNumber === 'lessThan' ? this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerNumber || 0 : 0}]`,
                                            indentation: 2,
                                        },
                                        {
                                            text: 'of resources',
                                            hint: ' ' + this.getAllowedResourcesHint(),
                                            indentation: 3,
                                        },
                                        {
                                            text: 'Someone says... ',
                                            hint: this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerType === 'spoken' ? '[selected]' : '',
                                            indentation: 1,
                                        },
                                        {
                                            text: 'Surname: ',
                                            hint: this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerSurname ? this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerSurname || 'anyone' : '',
                                            indentation: 2,
                                        },
                                        {
                                            text: 'says...',
                                            hint: this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerText ? this.props.orders.find(order => (order._id === this.state.selectedItem?._id)).triggerText : '',
                                            indentation: 2,
                                        },
                                    ]}
                                    menuContainer="equipment"
                                    optionChosen={this.triggerSettings.bind(this)}
                                    isWeightShowing={false}
                                    disabled={this.state.isQuantityInputShowing}
                                />
                            </div>
                            {
                                this.state.isQuantityInputShowing && (
                                    <QuantityInput
                                        quantity={1}
                                        onQuantitySupplied={this.state.onQuantitySupplied}
                                        onQuantityClosed={this.state.onQuantityClosed}
                                    />
                                )
                            }
                            {
                                this.state.isTextInputShowing && (
                                    <div className="search-bar">
                                        <p className="conversation-wizard-exit"><span className="action">ESC</span> to exit</p>
                                        <TextInput
                                            onTextSubmit={this.state.onTextInputSupplied}
                                            text={''}
                                            exitKey="Escape"
                                            onExitKey={this.state.onTextInputClosed}
                                        />
                                    </div>
                                )
                            }
                        </>
                    ) :
                    this.state.isCharacterZoneSelectShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={this.props.characterZones.map(zone => {
                                    const currentOrder = this.props.orders.find(order => (order._id === this.state.selectedItem?._id));


                                    const currentZone = this.props.characterZones.find(charZon => charZon._id === currentOrder.triggerZoneId);

                                    return {
                                        ...zone,
                                        text: zone.name,
                                        hint: currentZone?._id === zone._id ? '[selected]' : '',
                                    }
                                })}
                                    menuContainer="equipment"
                                    optionChosen={this.selectCharacterZone.bind(this)}
                                    isWeightShowing={false}
                                />
                            </div>
                        </>
                    ) :
                    this.state.isCharacterPanelSelectShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={this.props.characterPanels.map(panel => ({
                                    ...panel,
                                    text: panel.locationName,
                                    hint: selectedOrder.data?.panelIds?.find(panelId => (panelId === panel.panelId)) ? ' selected' : ''
                                }))}
                                    menuContainer="equipment"
                                    optionChosen={this.selectCharacterPanel.bind(this)}
                                    isWeightShowing={false}
                                />
                            </div>
                        </>
                    ) : this.state.isCharacterSelectShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={this.props.characters.map(character => ({
                                    ...character,
                                    text: character.name ?? 'Not present',
                                    hint: selectedOrder.data?.characterIds?.find(characterId => (characterId === character._id)) ? ' selected' : ''
                                }))}
                                    menuContainer="equipment"
                                    optionChosen={this.selectCharacter.bind(this)}
                                    isWeightShowing={false}
                                />
                            </div>
                        </>
                    ) : this.state.isCharacterOrganisationSelectShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={this.props.organisations.map(organisation => ({
                                    ...organisation,
                                    text: organisation.name ?? 'Not present',
                                    hint: selectedOrder.data?.organisationIds?.find(organisationId => (organisationId === organisation._id)) ? ' selected' : ''
                                }))}
                                    menuContainer="equipment"
                                    optionChosen={this.selectOrganisation.bind(this)}
                                    isWeightShowing={false}
                                />
                            </div>
                        </>
                    ) : this.state.isRepetitionsMenuShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={[
                                        { shortcut: '', text: ' No Repetitions', hint: this.state.selectedItem?.weight === SCHEDULE_REPETITIONS.SINGLE_TIME ? ' selected' : '', weight: '', },
                                        { shortcut: '', text: ' Repeats Daily', hint: this.state.selectedItem?.weight === SCHEDULE_REPETITIONS.ONCE_DAILY ? ' selected' : '', weight: '', },
                                        { shortcut: '', text: ' Repeat Until Sleep', hint: this.state.selectedItem?.weight === SCHEDULE_REPETITIONS.INDEFINITE_DAILY ? ' selected' : '', weight: '' },
                                    ].filter(option => (option.text === ' Repeat Until Sleep' && this.state.selectedItem?.text !== 'create' ? false : true))}
                                    menuContainer="equipment"
                                    isDisabled={!this.state.isRepetitionsMenuShowing}
                                    optionChosen={this.setRepetition.bind(this)}
                                    isWeightShowing={false}
                                />
                            </div>
                            <div className="conversation-tree-actions-container">
                                <p><span className="action">SPACE</span> - Select</p>
                                <p><span className="action">ESC</span> - Back to scheduled tasks</p>
                            </div>
                        </>
                    ) : this.state.isShowOrderGroups ? (
                    <>
                        <div className="equipment">
                            <Menu options={this.state.furnitureOrders.map(option => {
                                    option.className = this.getGroupingClass(option) ? option.className + ' ' + this.getGroupingClass(option) : option.className;
                                    option.groupText = this.getGroupText(option);
                                    return option
                                })} //.map(order => ({ ...order, weight: SCHEDULE_REPETITION_TEXTS_MAP[order.weight] }))
                                highlightedOption={this.onFurnitureOrderChosen.bind(this)}
                                menuContainer="equipment"
                                // isDisabled={this.state.isRepetitionsMenuShowing}
                                isGroupingMenu={true}
                            />

                        </div>
                        <div className="scheduler-actions">
                            <div className="conversation-tree-actions-container">
                                {
                                    this.props.isStoodOnDesk ? (
                                        <>
                                        <p><span className={"action"}>N</span> - Replace character orders with desk orders</p>
                                        <p><span className={"action"}>O</span> - Add desk orderes to character orders [will not add reaction orders]</p>
                                        <p><span className={"action"}>D</span> - Delete current desk order</p>
                                        </>
                                    ) : ('')
                                }
                                
                            </div>
                        </div>
                    </>
                    ) : this.state.isTimePeriodMenuShowing ? (
                        <>
                            <div className="equipment">
                                <Menu options={[
                                        { shortcut: '', text: ' Dawn', hint: this.isTimePeriodSelected(0) ? ' selected' : '' },
                                        { shortcut: '', text: ' Early Day', hint: this.isTimePeriodSelected(1) ? ' selected' : '' },
                                        { shortcut: '', text: ' Late Day', hint: this.isTimePeriodSelected(2) ? ' selected' : '' },
                                        { shortcut: '', text: ' Dusk', hint: this.isTimePeriodSelected(3) ? ' selected' : '' },
                                        { shortcut: '', text: ' Early Night', hint: this.isTimePeriodSelected(4) ? ' selected' : '' },
                                        { shortcut: '', text: ' Late Night', hint: this.isTimePeriodSelected(5) ? ' selected' : '' },
                                    ]}
                                    menuContainer="equipment"
                                    isDisabled={!this.state.isTimePeriodMenuShowing}
                                    optionChosen={this.setTimePeriod.bind(this)}
                                    isWeightShowing={false}
                                />
                            </div>
                            <div className="conversation-tree-actions-container">
                                <p><span className="action">SPACE</span> - Select</p>
                                <p><span className="action">ESC</span> - Back to scheduled tasks</p>
                            </div>
                        </>
                    ) : (
                        <>
                            {
                                this.state.isDirectionInputShowing && (
                                    <DirectionInput
                                        text={'Choose which direction to repeat the order in'}
                                        onDirectionSupplied={this.onDirectionSupplied}
                                        onDirectionClosed={this.onDirectionClosed}
                                        includeZDirections={true}
                                    />
                                )
                            }
                            {
                                this.state.isQuantityInputShowing && (
                                    <QuantityInput
                                        quantity={1}
                                        onQuantitySupplied={this.state.onQuantitySupplied}
                                        onQuantityClosed={this.state.onQuantityClosed}
                                    />
                                )
                            }
                            <div className="equipment">
                                <Menu options={this.state.orders.map(option => {
                                    option.className = this.getGroupingClass(option) ? option.className + ' ' + this.getGroupingClass(option) : option.className
                                    option.groupText = this.getGroupText(option);
                                    return option
                                })} //.map(order => ({ ...order, weight: SCHEDULE_REPETITION_TEXTS_MAP[order.weight] }))
                                    highlightedOption={this.onOrderChosen.bind(this)}
                                    menuContainer="equipment"
                                    isDisabled={this.state.isRepetitionsMenuShowing}
                                    isGroupingMenu={true}
                                />
                            </div>
                            <div className="scheduler-actions">
                                <div className="conversation-tree-actions-container">
                                    <p><span className={this.state.selectedItem?.hint.indexOf('DONE') > -1 ? "action" : "disabled action"}>,</span> - Redo order</p>
                                    <p><span className={this.state.selectedItem?.hint.indexOf('DONE') > -1 ? "disabled action" : "action"}>X</span> - Skip for the day</p>
                                    <p><span className={selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION ? "disabled action" : "action"}>R</span> - Set repetitions</p>
                                    <p><span className={"action"}>T</span> - Set time periods</p>
                                    <p><span className={"action"}>I</span> - Set triggers</p>
                                    <p><span className={selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION ? "disabled action" : "action"}>D</span> - Delete order</p>
                                    <p><span className={selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION ? "disabled action" : this.state.selectedItem?.hint.indexOf('DONE') > -1 ? "disabled action" : "action"}>W</span> - Set priority</p>
                                    <p><span className={selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION ? "disabled action" : "action"}>V</span> - Edit/View area</p>
                                    <p><span className={selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION ? "disabled action" : "action"}>Q</span> - Edit quantity</p>
                                    {
                                        this.props.isStoodOnDesk ? (
                                            <>
                                            <p><span className={"action"}>S</span> - Save orders to desk</p>
                                            <p><span className={"action"}>L</span> - Show desk orders</p>
                                            </>
                                        ) : ('')
                                    }
                                    
                                </div>
                            </div>
                            {selectedOrder?.weight === SCHEDULE_REPETITIONS.REACTION && 
                                <div className="scheduler-actions">
                                    <div className="conversation-tree-actions-container">
                                        {selectedOrder.data?.isOn !== undefined && (<p><span className="action">O</span> - Is On: <span className="hint">{selectedOrder.data?.isOn ? 'true' : 'false'}</span></p>)}
                                        {selectedOrder.data?.hunger && (<p><span className="action">H</span> - Hunger trigger: <span className="hint">{selectedOrder.data?.hunger}</span></p>)}
                                        {selectedOrder.data?.healthPoints && (<p><span className="action">E</span> - Health points: <span className="hint">{selectedOrder.data?.healthPoints}</span></p>)}
                                        {selectedOrder.data?.characterIds && (<p><span className="action">C</span> - Characters: <span className="hint">{selectedOrder.data?.characterIds.map(characterId => (this.props.characters.find(char => char._id === characterId)?.name ?? 'Unknown')).join(', ')}</span></p>)}
                                        {selectedOrder.data?.organisationIds && (<p><span className="action">G</span> - Organisations: <span className="hint">{selectedOrder.data?.organisationIds.map(organisationId => (this.props.organisations.find(org => org._id === organisationId)?.name ?? 'Unknown')).join(', ')}</span></p>)}
                                        {selectedOrder.data?.panelIds && (<p><span className="action">P</span> - Panels: <span className="hint">{(!selectedOrder.data?.panelIds || selectedOrder.data.panelIds.length === 0) ? selectedOrder.type === 'protect' ? 'No Panels': 'All panels' : this.props.characterPanels.filter(panel => (selectedOrder.data?.panelIds.indexOf(panel.panelId) > -1)).map(panel => (panel.locationName)).join(', ')}</span></p>)}
                                    </div>
                                </div>
                            }
                        </>
                    )
                }
                {
                    this.state.isResourceSelectShowing ? (
                        <div className="conversation-tree-actions-container">
                            <>
                                <p><span className="action">ENTER</span> - Toggle resource</p>
                                <p><span className="action">s</span> - Filter resources</p>
                            </>
                        </div>
                    ) : null
                }
                {
                    this.state.isSetOrderGroupInputShowing && (
                        <div className="search-bar">
                            <p className="conversation-wizard-exit"><span className="action">ESC</span> to exit</p>
                            <TextInput
                                onTextSubmit={this.state.onSetOrderGroupInputSupplied}
                                text={''}
                                exitKey="Escape"
                                onExitKey={this.state.onSetOrderGroupInputClosed}
                            />
                        </div>
                    )
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    const character = selectCharacter(state)
    const orders = selectCharacterOrders(state, character._id)
    const panel = selectPanel(state);
    const characterPanels = selectCharacterPanels(state);
    const characters = selectCharacters(state);
    const organisations = selectOrganisations(state);
    const zones = selectZones(state);
    const areaSelect = selectAreaSelect(state)

    const materialTypes = selectMaterialTypes(state);
    const mineralTypes = selectMineralTypes(state);
    // const plantTypes = selectPlantTypes(state);
    const tileTypes = selectTileTypes(state);
    const toolTypes = selectToolTypes(state);
    const metalTypes = selectMetalTypes(state);
    const keyTypes = selectKeyTypes(state);
    // const machineTypes = selectMachineTypes(state);
    const furnitureTypes = selectFurnitureTypes(state);
    // const constructionTypes = selectConstructionTypes(state);
    const writingSurfaceTypes = selectWritingSurfaceTypes(state);
    const writingImplementTypes = selectWritingImplementTypes(state);
    const weaponTypes = selectWeaponTypes(state);
    const armourTypes = selectArmourTypes(state);
    const clothingTypes = selectClothingTypes(state);
    const jewelleryTypes = selectJewelleryTypes(state);
    const foodTypes = selectFoodTypes(state);
    // const lockTypes = selectLockTypes(state);
    // const animalTypes = selectAnimalTypes(state);
    // const boatTypes = selectBoatTypes(state);
    // const brainchipTypes = selectBrainchipTypes(state);
    // const tentTypes = selectTentTypes(state);
    const workshopTypes = selectWorkshopTypes(state);
    // const wagonTypes = selectWagonTypes(state);
    // const plantProducts = selectPlantProducts(state);
    // const constructionRecipes = selectConstructionRecipes(state);

    const characterZones = selectCharacterZones(state, character._id);

    const furnitureAtPosition = selectFurnitureByPosition(state, character.position);

    const isStoodOnDesk = furnitureAtPosition.find(furniture => furniture?.furnitureType?.name === 'Desk');
    const furnitureOrders = selectFurnitureOrders(state, isStoodOnDesk?._id);

    return {
        orders,
        furnitureOrders,
        character,
        characterPanels,
        characters,
        organisations,
        zones,
        areaSelect,
        materialTypes,
        mineralTypes,
        // plantTypes,
        tileTypes,
        toolTypes,
        metalTypes,
        keyTypes,
        furnitureTypes,
        writingSurfaceTypes,
        writingImplementTypes,
        weaponTypes,
        armourTypes,
        clothingTypes,
        jewelleryTypes,
        foodTypes,
        workshopTypes,
        characterZones,
        isStoodOnDesk
    }
}

export default connect(
    mapStateToProps,
    { stopAreaSelect, startAreaSelect, hideAllMenus, deleteOrderAsync, updateOrderAsync, skipOrderAsync, createOrderAsync, deleteCompletedOrderAsync, updateCompletedOrderAsync }
)(Scheduler);